/* Roost & Roam — scroll reveal + hero parallax.
 * Pairs with rr-reveal.css. Idempotent, safe to load more than once. */
(function () {
  'use strict';

  if (window.__rrReveal) return;
  window.__rrReveal = true;

  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function markInView(el) {
    el.classList.add('in-view');
  }

  function init() {
    var targets = document.querySelectorAll(
      '.fade-up, .reveal-mask, .img-reveal, .wipe-in, .fade-in'
    );

    if (prefersReduced || !('IntersectionObserver' in window)) {
      // Skip the show; just reveal everything immediately.
      targets.forEach(markInView);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          markInView(entry.target);
          // reveal-mask can contain stagger children that trigger off the parent's class,
          // so we stop observing for all kinds — the `.in-view` flip is one-shot.
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    targets.forEach(function (el) { io.observe(el); });

    // Above-the-fold reveals.
    //
    // Two mechanisms run in parallel:
    //   1. Mark the subtree `.in-view` so IO-style .reveal-mask / .fade-up
    //      / .img-reveal / .wipe-in / .fade-in classes paint at rest.
    //   2. Add `.loaded` shortly after the next paint. The spec-exact
    //      hero line reveal uses a transition keyed on the ancestor's
    //      `.loaded` class — the class MUST flip AFTER first paint for
    //      the browser to observe the initial translate(110%) state and
    //      run the transition. Hence: rAF → setTimeout(80).
    requestAnimationFrame(function () {
      document.querySelectorAll('[data-rr-reveal-on-load]').forEach(function (el) {
        el.classList.add('in-view');
        el.querySelectorAll('.reveal-mask, .fade-up, .img-reveal, .wipe-in, .fade-in')
          .forEach(markInView);
      });
      setTimeout(function () {
        document.querySelectorAll('[data-rr-reveal-on-load]').forEach(function (el) {
          el.classList.add('loaded');
        });
      }, 80);
    });

    // Hero parallax — opt-in via [data-rr-parallax] on a background element.
    var parallaxNodes = document.querySelectorAll('[data-rr-parallax]');
    if (parallaxNodes.length) {
      var ticking = false;
      var update = function () {
        var y = window.scrollY || 0;
        parallaxNodes.forEach(function (node) {
          var rate = parseFloat(node.getAttribute('data-rr-parallax')) || 0.25;
          var rect = node.getBoundingClientRect();
          // Only translate while the element is roughly on-screen
          if (rect.bottom < -200 || rect.top > window.innerHeight + 200) return;
          node.style.setProperty('--rr-parallax', (y * rate).toFixed(1) + 'px');
        });
        ticking = false;
      };
      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(update);
        },
        { passive: true }
      );
      update();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
